angular.module('unergie.main')
.directive('timetablemodifications', ($rootScope, AlertManager, DataAccess, TimetableModificationsService, BoFeaturesService, MS,
    ContractService, ApiUser, DataAccessTimetableModifs, DataAccessSearch, AdminComments, ErrorCatcher, ContractConstants) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/timetablemodifications/timetablemodifications.html',
        link: {
            post($scope) {
                $scope.contractElec = null
                $scope.revision = 0
                $scope.timetables = []
                $scope.isActive = false

                let graph = null
                const selector = '#visModifs'

                $scope.fineGrainedTimetableModifs = BoFeaturesService.isFeatureOn('fineGrainedTimetableModifs')

                $scope.availableRevisions = [50, 40, 30, 20, 15, 10, 5, 0, -5, -10, -15, -20, -30, -40, -50]

                $scope.setRev = (rev) =>
                    $scope.$applyAsync(() => {
                        $scope.revision = rev
                    })


                $scope.setRevision = () => graph.reloadWithRevision($scope.revision)

                $scope.setAmount = () => {
                    const firstUnlock = _.find(graph.getData(), { lock: false }).timetable
                    const ratio = Number($scope.amount) / (firstUnlock.total + firstUnlock.modification)
                    $scope.revision = MS.round((ratio - 1) * 100, 2)
                    $scope.setRevision()
                }

                const load = (contractElec) => {
                    $scope.loadingTTModif = true
                    $scope.errorMessage = undefined
                    $scope.contractElec = contractElec
                    $scope.isActive = contractElec.status === ContractConstants.status.EN_SERVICE
                    // return DataAccessTimetableModifs.get({ id_contract: contractElec.id }).$promise.then((data) => {
                    return DataAccessSearch({ orderBy: 'timetable_date' }).search({ resource: 'timetables', id_contract: contractElec.id, status: 0 }).$promise.then((timetables) => {
                        if (timetables.length > 0) {
                            if (timetables.length === 1) {
                                d3.selectAll(selector).select('svg').remove()
                                $scope.errorMessage = 'Pas de modification possible sur 1 seul mois'
                                return
                            }
                            $scope.setRev(timetables[0].revision || 0)
                            $scope.timetables = timetables
                            graph = TimetableModificationsService.display(selector, timetables)
                            return
                        }
                        d3.selectAll(selector).select('svg').remove()
                        $scope.errorMessage = "Pas d'échéancier disponible"
                    })
                    .catch(ErrorCatcher)
                    .finally(() => {
                        $scope.loadingTTModif = false
                    })
                }

                $scope.save = () => {
                    $scope.savingTTModif = true
                    const toSave = []
                    _.forEach($scope.timetables, (timetable) => {
                        const tt = {
                            id_payment_timetable: timetable.id,
                            modification: timetable.modification || 0,
                            revision: timetable.revision || 0,
                        }
                        if (timetable.id_modification) {
                            tt.id = timetable.id_modification
                        }
                        toSave.push(tt)
                    })
                    return DataAccessTimetableModifs.set({ id_contract: $scope.contractElec.id }, toSave).$promise.then((data) => {
                        AlertManager.success('Échéancier modifié')
                        const comment = '<b>AUTOMATIQUE</b> : échéancier modifié à la main'
                        AdminComments.addComment({ object: $scope.contractElec.id, comment }).$promise.catch(ErrorCatcher)
                        $scope.refreshGraph()
                    })
                    .catch(ErrorCatcher)
                    .finally(() => {
                        $scope.savingTTModif = false
                    })
                }

                ContractService.watch('timetablemodifications', load)

                if (window.ResizeObserver) {
                    const rsObserver = new window.ResizeObserver((listResized) => {
                        listResized.forEach((e) => {
                            if (e.contentRect.height > 0) {
                                graph = TimetableModificationsService.display(selector, $scope.timetables)
                            }
                        })
                    })
                    rsObserver.observe(document.querySelector(selector))
                }

                $scope.refreshGraph = () => load($scope.contractElec)

                $scope.sendTimetableMail = () =>
                    ApiUser.adminSendMail({ id_contract: $scope.contractElec.id, id_account: $scope.contractElec.id_account }, { template: 'timetable_modif' }).$promise
                    .then(() =>
                        AlertManager.success(`Email envoyé à ${$scope.account != null ? $scope.account.mail : undefined}`))
                    .catch(ErrorCatcher)
            },
        },
    })
)
